import _             from 'underscore';
import React, { FC } from 'react';

import { useQuery }              from '@apollo/react-hooks';
import { DecisionEngineQueries } from '../../../../queries';
import { formatOption }          from '../../../../util';
import { SelectField }           from '../../../components/forms';
import { Uuid }                  from '../../../../types';
import { EMPTY_VALUE_DISPLAY }   from '../../../../constants/FormatStringEnums';

interface DataValueSetItemDropdownProps {
	id: Uuid,
	loading?: boolean,
	noIDLabel?: string,
	
	[ additionalProps: string ]: any
}

const defaultProps: DataValueSetItemDropdownProps = {
	id:        null,
	loading:   false,
	noIDLabel: EMPTY_VALUE_DISPLAY,
}

const QueryDropdown: FC<DataValueSetItemDropdownProps> = ( _props ) => {
	
	// no id, no bueno.
	let { noIDLabel, ...props } = _props;
	
	if( !props.id ){
		return (
			<SelectField
				{ ...props }
				options={ [] }
				placeholder={ props.noIDLabel }>
			</SelectField>
		);
	}
	
	let { data, loading, error } = useQuery( DecisionEngineQueries.queries.GET_DATA_VALUE_SET( `id name items{ id value ordinal }` ), {
		fetchPolicy: 'cache-and-network',
		variables:   {
			id: props.id
		}
	} );
	
	let isLoading = ( props.loading || loading );
	
	let options = ( data )
	              ? _.sortBy( data.dataValueSet.items, 'ordinal' ).map( ( { id, value } ) => formatOption( id, value ) )
	              : [];
	
	return (
		<SelectField
			{ ...props }
			loading={ isLoading }
			options={ options }>
		</SelectField>
	);
};

QueryDropdown.defaultProps = defaultProps;

export { QueryDropdown as DataValueSetItemDropdown };
